import React, { Component } from 'react';
import PropTypes from 'prop-types';

import Drawer from '@mui/material/Drawer';
import Avatar from '@mui/material/Avatar';
import DynamicMenu from '../menu/sidemenu/DynamicMenu';
import { Box, Stack, Typography, type Theme } from '@mui/material';

const drawerWidth = 240;
const miniDrawerWidth = 60;

const s:any = {
  
  menuButton: {
    marginLeft: 1, //12,
    marginRight: 1, //36,
  },
  hide: {
    display: "none",
  },
  rootPaper: {
    position: "relative",
  },
  drawerPaper: (theme:Theme)=>({
    [theme.breakpoints.down('sm')]:{
      width: miniDrawerWidth,
      overflowX: 'hidden',
    },
    position: 'relative',
    whiteSpace: 'nowrap',
    height: '100%',
    width: drawerWidth,
    transition: theme.transitions.create('width', {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.enteringScreen,
    }),
  }),
  drawerPaperClose: {
    width:0,
  },
  drawerHeader: (theme:Theme)=>({
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    minHeight: '64px',
    padding: '0 8px',
    ...theme.mixins.toolbar,
  }),
};

class LeftDrawer extends Component<any,any> {
  static propTypes: any;
  static defaultProps: any;
  constructor(props:any) {
    super(props);
    this.state = {
      selectedItem: null
    };
  }

  menuname=(menu:string)=>{
    return menu.replace('/','');
  }

  handleClick = (menu:any,page:any,index:any)=> () => {
    console.log('handleclick:menu,page,index',menu,page,index);
    this.props.handleSetContent(null,page).then( () => {
      this.props.closeDrawer();
    });
    
  }

  render(){
    const { data, navDrawerOpen, closeDrawer } = this.props;
    const {nam = 'Signed-in user', unm = '', rnm = 'User'} = (data.bd||{});
    const avatarsrc = unm ? `/api/photo/${encodeURIComponent(unm)}` : undefined;
    const logosrc = `/lib/img/logo.png`;

    const initials = String(nam)
      .split(/\s+/)
      .filter(Boolean)
      .slice(0, 2)
      .map((part) => part.charAt(0).toUpperCase())
      .join('');

    return (
      <Drawer
        variant="persistent"
        open={navDrawerOpen}
        onClose={closeDrawer}
        PaperProps={{
          sx: (theme) => ({
            ...s.drawerPaper(theme),
            width: navDrawerOpen ? drawerWidth : 0,
            overflowX: 'hidden',
            bgcolor: '#FFFFFF',
            borderRight: '1px solid #E1E3E2',
            boxShadow: '6px 0 24px rgba(31,34,34,0.08)',
          })
        }}
        sx={{
          order: 0,
          width: navDrawerOpen ? drawerWidth : 0,
          flex: `0 0 ${navDrawerOpen ? drawerWidth : 0}px`,
          flexShrink: 0,
          overflow: 'hidden',
        }}
      >
      <Box sx={{ minHeight: '100%', bgcolor: '#FFFFFF' }}>
        <Box
          sx={{
            position: 'relative',
            px: 2,
            py: 2.25,
            color: '#FFFFFF',
            background: 'linear-gradient(145deg, #242829 0%, #363A3B 100%)',
            borderTop: '4px solid #F27400',
          }}
        >
          <Stack direction="row" spacing={1.4} alignItems="center">
            <Box
              aria-hidden="true"
              sx={{
                width: 38,
                height: 38,
                flex: '0 0 38px',
                display: 'grid',
                placeItems: 'center',
                borderRadius: '10px',
                bgcolor: '#FFF',
                color: '#FFFFFF',
                fontSize: 18,
                fontWeight: 900,
                boxShadow: '0 6px 16px rgba(242,116,0,0.28)',
              }}
            >
              <img src={logosrc} alt="Logo" style={{ width: '24px', height: '24px' }} />
            </Box>
            <Box sx={{ minWidth: 0 }}>
              <Typography
                sx={{
                  color: '#FFFFFF',
                  fontWeight: 900,
                  fontSize: 16,
                  lineHeight: 1.2,
                  letterSpacing: '0.035em',
                }}
              >
                K-FRONTIERS
              </Typography>
              <Typography
                sx={{
                  mt: 0.45,
                  color: '#CDD0D0',
                  fontSize: 11.5,
                  fontWeight: 600,
                  letterSpacing: '0.025em',
                }}
              >
                Sales Management System
              </Typography>
            </Box>
          </Stack>
        </Box>

        <Box
          sx={{
            px: 2,
            py: 1.75,
            bgcolor: '#4B4F50',
            borderBottom: '1px solid #5A5F60',
          }}
        >
          <Stack direction="row" spacing={1.4} alignItems="center">
            <Avatar
              src={avatarsrc}
              alt={nam}
              sx={{
                width: 42,
                height: 42,
                flex: '0 0 42px',
                bgcolor: '#F27400',
                color: '#FFFFFF',
                fontSize: 14,
                fontWeight: 800,
                border: '2px solid rgba(255,255,255,0.72)',
              }}
            >
              {initials}
            </Avatar>
            <Box sx={{ minWidth: 0 }}>
              <Typography
                sx={{
                  mb: 0.25,
                  color: '#C9CCCB',
                  fontSize: 9.5,
                  fontWeight: 800,
                  lineHeight: 1.2,
                  letterSpacing: '0.09em',
                  textTransform: 'uppercase',
                }}
              >
                Signed in as
              </Typography>
              <Typography
                title={nam}
                sx={{
                  color: '#FFFFFF',
                  fontSize: 13,
                  lineHeight: 1.35,
                  fontWeight: 800,
                  overflow: 'hidden',
                  overflowWrap: 'anywhere',
                  display: '-webkit-box',
                  WebkitBoxOrient: 'vertical',
                  WebkitLineClamp: 2,
                }}
              >
                {nam}
              </Typography>
              <Typography
                title={rnm}
                sx={{
                  mt: 0.25,
                  color: '#E5E7E7',
                  fontSize: 11,
                  lineHeight: 1.3,
                  fontWeight: 500,
                  overflow: 'hidden',
                  textOverflow: 'ellipsis',
                  whiteSpace: 'nowrap',
                }}
              >
                {rnm}
              </Typography>
            </Box>
          </Stack>
        </Box>

        <DynamicMenu data={data} handleClick={this.handleClick}/>
      </Box>
    </Drawer>
    );
  }
}

LeftDrawer.propTypes = {
  navDrawerOpen: PropTypes.bool,
  menus: PropTypes.array,
  username: PropTypes.string,
  data: PropTypes.object,
  handleSetContent:PropTypes.func
};

export default LeftDrawer;
